/* eslint-disable react/jsx-props-no-spreading */
import {
    Col, Form, FormInstance, FormProps, Grid, Input, Row,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { forwardRef } from 'react';
import { getRequiredFieldMessage } from '../helpers/form';
import { usePackageUnits } from '../hooks/usePackageUnits';
import { USER_ROLE_MODERATOR_LIMITED, useUser } from '../hooks/useUser';
import { useFormWatchMode } from '../hooks/useFormWatchMode';

const { useBreakpoint } = Grid;

function PurchaseItemForm(props: FormProps, ref: any) {
    const { lg } = useBreakpoint();
    const { t } = useTranslation();
    const packageUnits = usePackageUnits(true);
    const user = useUser({ canFetch: false, canLogoutBy401: false, showFetchMessages: false });
    const { getFieldMandatory, readOnly } = useFormWatchMode(user.info?.role_value === USER_ROLE_MODERATOR_LIMITED);

    return (
        <Form layout="vertical" ref={ref} {...props}>
            <Row gutter={[30, 30]}>
                <Col xs={24}>
                    <Form.Item
                        name="name"
                        label={t('goodName')}
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('goodName')) }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item
                        name="ru_name"
                        label={t('orderPackageRuName')}
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageRuName')) }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="tncode"
                        label={t('orderPackageCode')}
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageCode')) }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="count"
                        label={t('orderPackageItemsCount')}
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageItemsCount')) }]}
                    >
                        <Input readOnly={readOnly} type="number" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="price"
                        label={lg ? `${t('orderPackageCost')} (${t('perItem')})` : t('orderPackageCost')}
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageCost')) }]}
                    >
                        <Input readOnly={readOnly} />
                    </Form.Item>
                </Col>
                <Col xs={12}>
                    <Form.Item
                        label={lg ? `${t('orderPackageWeight')} (${t('perItem')})` : t('orderPackageWeight')}
                        name="weight"
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageWeight')) }]}
                    >
                        <Input
                            readOnly={readOnly}
                            onKeyPress={(event) => {
                                if (!/[0-9,.]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            type="number"
                            suffix={packageUnits.data?.weight[0].label}
                        />
                    </Form.Item>
                    <Form.Item hidden name="weight_unit" />
                </Col>
                <Col xs={12}>
                    <Form.Item
                        label={lg ? `${t('orderPackageWidth')} (${t('perItem')})` : t('orderPackageWidth')}
                        name="width"
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageWidth')) }]}
                    >
                        <Input readOnly={readOnly} suffix={packageUnits.data?.linear[0].label} />
                    </Form.Item>
                    <Form.Item hidden name="width_unit" />
                </Col>
                <Col xs={12}>
                    <Form.Item
                        label={lg ? `${t('orderPackageLength')} (${t('perItem')})` : t('orderPackageLength')}
                        name="length"
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageLength')) }]}
                    >
                        <Input suffix={packageUnits.data?.linear[0].label} />
                    </Form.Item>
                    <Form.Item hidden name="length_unit" />
                </Col>
                <Col xs={12}>
                    <Form.Item
                        label={lg ? `${t('orderPackageHeight')} (${t('perItem')})` : t('orderPackageHeight')}
                        name="height"
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageHeight')) }]}
                    >
                        <Input readOnly={readOnly} suffix={packageUnits.data?.linear[0].label} />
                    </Form.Item>
                    <Form.Item hidden name="height_unit" />
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="url"
                        label={t('orderPackageItemUrl')}
                        rules={[{ required: getFieldMandatory(true), message: getRequiredFieldMessage(t('orderPackageItemUrl')) }]}
                    >
                        <Input readOnly={readOnly} />
                    </Form.Item>
                </Col>
                <Form.Item name="currency" hidden />
            </Row>
        </Form>
    );
}

export default forwardRef<FormInstance, FormProps>(PurchaseItemForm);
